import { useEffect, useState } from 'react';
import { addDocument, getAllDocuments } from '../services/firestore';
import { Button, Box, Typography, List, ListItem, ListItemText } from '@mui/material';

const FirestoreTest = () => {
  const [testData, setTestData] = useState<any[]>([]);
  const [status, setStatus] = useState('');
  const [error, setError] = useState('');

  const addTestData = async () => {
    try {
      setStatus('Adding test data...');
      const testDoc = {
        name: 'Test Item ' + Date.now(),
        description: 'This is a test document',
        createdAt: new Date().toISOString(),
        value: Math.floor(Math.random() * 1000)
      };
      
      await addDocument('testCollection', testDoc);
      setStatus('Test data added successfully!');
      loadTestData();
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : 'An unknown error occurred';
      setError(`Error adding test data: ${errorMessage}`);
      setStatus('');
    }
  };

  const loadTestData = async () => {
    try {
      const data = await getAllDocuments('testCollection');
      setTestData(data);
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : 'An unknown error occurred';
      setError(`Error loading test data: ${errorMessage}`);
    }
  };

  useEffect(() => {
    loadTestData();
  }, []);

  return (
    <Box sx={{ 
      padding: 3, 
      maxWidth: 600, 
      margin: '0 auto',
      backgroundColor: 'background.paper',
      borderRadius: 2,
      boxShadow: 1,
      p: 3
    }}>
      <Typography variant="h4" gutterBottom>
        Firestore Test
      </Typography>
      
      <Button 
        variant="contained" 
        onClick={addTestData}
        sx={{ mb: 2 }}
      >
        Add Test Data
      </Button>
      
      <Button 
        variant="outlined" 
        onClick={loadTestData}
        sx={{ mb: 2, ml: 2 }}
      >
        Refresh Data
      </Button>
      
      {status && <Typography color="primary" sx={{ mt: 1 }}>{status}</Typography>}
      {error && <Typography color="error" sx={{ mt: 1 }}>{error}</Typography>}
      
      <Typography variant="h6" sx={{ mt: 3, mb: 1 }}>
        Test Data in Firestore:
      </Typography>
      
      {testData.length === 0 ? (
        <Typography>No test data found. Click "Add Test Data" to create some.</Typography>
      ) : (
        <List dense>
          {testData.map((item) => (
            <ListItem key={item.id} divider>
              <ListItemText 
                primary={item.name}
                secondary={`Value: ${item.value} | Created: ${new Date(item.createdAt).toLocaleString()}`}
              />
            </ListItem>
          ))}
        </List>
      )}
    </Box>
  );
};

export default FirestoreTest;
